import {Injectable} from '@angular/core';
import {GraphKnDataService} from './graph-kn.data.service';
import {Vector2d} from 'konva/lib/types';
import {Arrow} from 'konva/lib/shapes/Arrow';
import {Group} from 'konva/lib/Group';
import {SCALE_BY} from '../models/graph-kn.cm.model-const';
import {Rect} from 'konva/lib/shapes/Rect';
import {Layer} from 'konva/lib/Layer';
import {IDimensions} from '../models/graph-kn.model-interfaces';
import {
    ARROW_LINK_SUBCONTRACT_MODEL,
    ARROW_LINK_TASK_MODEL,
    ARROW_POINTER_MARGIN,
    ARROW_START_MARGIN,
    MIN_ARROW_LENGTH,
} from '../models/graph-kn.cm.arrows-model-const';
import { XYEdgeService } from './xyflow-edge.service';
import { IEdgePointersData } from '../models/xyflow.models';
import { EEdgyType, Position } from '../models/graph-kn.model-enums';
import { RectModelsMap } from '../styles/graph-node-rect-model';

type TConnectorType = 'subContract'

@Injectable({
    providedIn: 'root'
})
export class GraphKnConnectorsLayersService {
    constructor(
        private knDataService: GraphKnDataService,
        private xyEdgeService: XYEdgeService,
    ) {
    }
    createLinkToActiveStep(layerBP: Layer, toNodeBP: string, contractLayerId: string) {
        let layerFrom = this.knDataService.layersMap.get(contractLayerId)?.layer
        if (layerFrom) {
            this.knDataService.linkEdge ? this.knDataService.linkEdge.destroy() : null;
            let fromNode = layerFrom.findOne('#' + this.knDataService?.selectedNodeGroup?.attrs.id) as Group
            let toNode = layerBP.findOne('#' + toNodeBP.toString()) as Group
            this.knDataService.linkEdge = new Arrow({
                fromLayer: contractLayerId,
                from: fromNode?.attrs.id,
                to: toNode?.attrs.id,
                ...ARROW_LINK_TASK_MODEL,
                //tension: 0.1
            })
          
            let fromNodeRect = fromNode?.children.filter(child => child instanceof Rect)
            if (fromNode && toNode ) {
              let edgePointData: IEdgePointersData = {
                pointFrom:{
                  x:fromNode.x() + (fromNodeRect[0]?.attrs.width || 0) / 2,
                  y:fromNode.y() + fromNodeRect[0]?.attrs.height || 0 + ARROW_START_MARGIN
                },
                pointFromPosition:Position.Bottom,
                pointTo:{
                  x:toNode.getAbsolutePosition().x + (fromNodeRect[0]?.attrs.width || 0) / 2,
                  y:toNode.getAbsolutePosition().y - ARROW_POINTER_MARGIN - layerFrom.getAbsolutePosition().y
                },
                pointToPosition:Position.Top
              }
              let pathData = this.xyEdgeService.calcEdgeXYPath(edgePointData,EEdgyType.SmoothStep)
              let ind = pathData?.points?.length? pathData?.points?.length - 4 : undefined
              pathData.points && ind? pathData.points.splice(ind,2) : null
              this.knDataService.linkEdge.points(pathData.points)
            }
            layerFrom.add(this.knDataService.linkEdge)
            this.knDataService.linkEdge?.moveToBottom()
           // layerFrom.add(this.knDataService.linkPath)
            this.knDataService.linkPath?.moveToBottom()
            this.knDataService.canvasObjectsMap.set('LinkToActiveStepPath', {contextMenu: false})
  
        }
    }

    connectContractLayers(topLayerId: string, bottomLayerId: string, connectorType?: TConnectorType) {
        let topLayer = this.knDataService.layersMap.get(topLayerId)?.layer;
        let bottomLayer = this.knDataService.layersMap.get(bottomLayerId)?.layer;
        let fromNodeData = topLayer?.findOne('#' + this.knDataService.selectedNodeGroupId) as Group
        let fromNode = fromNodeData?.position()
        let activeSubContractStepId = '';
        this.knDataService.contractNodes.get(bottomLayerId)?.every(node => {
            activeSubContractStepId = node.node?.id||''
            return node.node?.contract_step_data?.completed_at != null
        })
        let toNodeData = bottomLayer?.findOne('#' + activeSubContractStepId) as Group;
        let toNode = toNodeData.position();
        let connectEdge = new Arrow({
            ...ARROW_LINK_SUBCONTRACT_MODEL,
        });
        // либо апдейт существующего ребра между контрактом и субконтрактом ИЛИ создание нового ребра связи
        let existConnectEdgeInx = this.knDataService.contractConnectors.findIndex(ce => ce.fromLayerID === topLayerId)
        let oldConnectEdge = topLayer?.findOne('#connect_edge') as Arrow;
        if (existConnectEdgeInx >= 0) {
            oldConnectEdge ? connectEdge = oldConnectEdge : null;
            this.knDataService.contractConnectors[existConnectEdgeInx].toLayerID = bottomLayerId
            this.knDataService.contractConnectors[existConnectEdgeInx].toId = toNodeData.id()
        } else {
            this.knDataService.contractConnectors.push({
                arrow: connectEdge,
                fromId: fromNodeData.id(),
                toId: toNodeData.id(),
                toLayerID: bottomLayerId,
                fromLayerID: topLayerId,
            })
        }
        let rectModel = RectModelsMap.get('contractStep')
        let gapBwLayers = bottomLayer && topLayer ?
            bottomLayer.getAbsolutePosition().y - topLayer.getAbsolutePosition().y - (this.knDataService.nodeHeight || rectModel!.height!)
            : 0;
        topLayer?.add(connectEdge)
        connectEdge.moveToTop()
        if (fromNode && toNode) {
            let layerGap = ((bottomLayer?.y() || 0) - (topLayer?.y() || 0))
            let points = this.connectEdgeCalcPoints(toNodeData, fromNode, fromNodeData.attrs.dimensions, gapBwLayers, layerGap, connectorType)
            connectEdge.points(points)
        }
    }

    connectEdgeCalcPoints(toNodeData: Group, fromNode: Vector2d, fromNodeDimensions: IDimensions, gapBwLayers: number, gap: number, connectorType?: TConnectorType): number[] {
        let points: number [];
        let rectModel = RectModelsMap.get('contractStep')
        switch (connectorType) {
            case 'subContract':
                points = [
                    fromNode.x - ARROW_START_MARGIN,
                    fromNode.y + (this.knDataService.nodeHeight || rectModel!.height!) * 0.75,
                    fromNode.x - MIN_ARROW_LENGTH / 2 - ARROW_START_MARGIN,
                    fromNode.y + (this.knDataService.nodeHeight || rectModel!.height!) * 0.75,
                    fromNode.x - MIN_ARROW_LENGTH / 2 - ARROW_START_MARGIN,
                    toNodeData?.y() + (gap) - (this.knDataService.nodeHeight || rectModel!.height!) / 2,
                    toNodeData?.getAbsolutePosition().x + fromNodeDimensions.width / 2,
                    toNodeData?.y() + (gap) - (this.knDataService.nodeHeight || rectModel!.height!) / 2,
                    toNodeData?.getAbsolutePosition().x + fromNodeDimensions.width / 2,
                    toNodeData?.y() + (gap) - ARROW_POINTER_MARGIN
                ]
                break;
            default:
                points = [
                    fromNode.x + fromNodeDimensions.width / 2,
                    fromNode.y + (this.knDataService.nodeHeight || rectModel!.height!),
                    fromNode.x + fromNodeDimensions.width / 2,
                    fromNode.y + (this.knDataService.nodeHeight || rectModel!.height!) + 0.5 * gapBwLayers,
                    toNodeData?.getAbsolutePosition().x + fromNodeDimensions.width / 2,
                    fromNode?.y + (this.knDataService.nodeHeight || rectModel!.height!) + 0.52 * gapBwLayers,
                    toNodeData?.getAbsolutePosition().x + fromNodeDimensions.width / 2,
                    toNodeData?.y() + (gap) - ARROW_POINTER_MARGIN
                    + (toNodeData.y() < fromNode.y ? (this.knDataService.nodeHeight || rectModel!.height!) + 2 * ARROW_POINTER_MARGIN : 0)
                ]
                break
        }
        return points
    }

    adjustContractConnector(targetID: string, movement: Vector2d, layerId?: string) {
        targetID === 'null' && layerId ?
            targetID = this.knDataService.contractConnectors.filter(ce => ce.fromLayerID === layerId)[0]?.toId || 'null' : null;
        this.knDataService.contractConnectors
            .filter(ce => [ce.fromId, ce.toId].includes(targetID))
            ?.forEach(ce => {
                let lastInx = ce.arrow.attrs.points.length - 1
                let p = ce.arrow.attrs.points;
                if (ce.fromId === targetID) {
                    p[0] = p[0] + movement.x;
                    p[1] = p[1] + movement.y;
                    p[2] = p[2] + movement.x;
                } else {
                    p[lastInx - 4] = p[lastInx - 4] + movement.y;
                    p[lastInx - 3] = p[lastInx - 3] + movement.x;
                    p[lastInx - 2] = p[lastInx - 2] + movement.y;
                    p[lastInx - 1] = p[lastInx - 1] + movement.x;
                    p[lastInx] = p[lastInx] + movement.y;
                }
                ce.arrow.points(p)
            })
    }

    zoomContractConnector(layerId: string, direction: number) {
        let connectors = this.knDataService.contractConnectors.filter(ce => ce.fromLayerID === layerId)
        if (connectors?.length) {
            let connectorArrow = connectors[0].arrow;
            let p = connectorArrow.attrs.points
            p[6] = direction === -1 ? p[4] * SCALE_BY : p[4] / SCALE_BY
            p[6] = direction === -1 ? p[6] * SCALE_BY : p[6] / SCALE_BY
            p[7] = direction === -1 ? p[7] * SCALE_BY : p[7] / SCALE_BY
            connectorArrow.points(p)
        }
    }
}